const CONTACT_US_WELCOME = 'https://support.fabfitfun.com/';
const CUSTOM_CARE_URL =
  'https://support.fabfitfun.com/en/articles/44-how-can-i-contact-customer-care';

export { CONTACT_US_WELCOME, CUSTOM_CARE_URL };
